import { useShallow } from 'zustand/react/shallow';

import { trpc } from '@/services/trpc';
import { useBoundStore } from '@/store/store';

export function useOrganizationMutation() {
  const utils = trpc.useUtils();
  const { setCurrentOrganizationId, setJwt } = useBoundStore(
    useShallow(state => ({
      setCurrentOrganizationId: state.setCurrentOrganizationId,
      setJwt: state.setJwt,
    })),
  );

  const create = trpc.organizations.create.useMutation({
    onSuccess: async data => {
      setJwt(data.access);

      setCurrentOrganizationId(data.organization.id);

      await utils.organizations.findAll.invalidate();
      await utils.chats.findAll.invalidate();
      await utils.users.findAll.invalidate();
      await utils.users.me.invalidate();
    },
  });

  const update = trpc.organizations.update.useMutation({
    onSuccess: async (data, { id }) => {
      await Promise.all([
        utils.organizations.findAll.invalidate(),
        utils.organizations.findOne.invalidate({ id }),
        utils.chats.findOne.invalidate(),
      ]);
    },
  });

  const remove = trpc.organizations.delete.useMutation({
    onSuccess: async data => {
      setJwt(data.access);
      setCurrentOrganizationId(data.organization.id);

      await utils.organizations.findAll.invalidate();
      await utils.users.findAll.invalidate();
      await utils.chats.findAll.invalidate();
      await utils.users.me.invalidate();
    },
  });

  return {
    create,
    update,
    remove,
  };
}
